module.exports = __webpack_public_path__ + "assets/img/tx280_1.41f5076c.jpg";